import {StyleSheet} from 'react-native';

import {cloudLight, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  section: {
    flex: 1,
    backgroundColor: white,
    marginTop: 20,
  },
  listItemTitle: {
    marginBottom: 4,
  },
  fakeInput: {
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    display: 'flex',
    marginBottom: 10,
  },
});
